import React from "react";
import Dashboard from "components/dashboard";
import { PageSection, PageHeaderBar } from "components/page";
import { QueryResponseHandler } from "components/graphql";
import { useEventDetailsRest } from "./details-page/rest-event-adapter";
import { RestrictedEventVisible } from "pages/event/utils";
import { FormattedMessage } from "react-intl";
import LiveEmissionPlayer, { WarningLocalUrl } from "./live-emission";

const EventLiveEmissionPage = ({
  match: {
    params: { id },
  },
  history,
  intl,
}) => {
  const { event, loading, error } = useEventDetailsRest({ eventId: id, withEvu: true });

  return (
    <Dashboard>
      <QueryResponseHandler error={error} loading={loading} elements={event}>
        <RestrictedEventVisible event={event}>
          <PageHeaderBar
            showBackButton
            title="app.page.event.liveEmision.title"
            titleParams={{ eventTitle: event ? event.title : "" }}
          />
          <PageSection>
            <FormattedMessage id="app.page.event.liveEmision.description" />
            <WarningLocalUrl event={event}>
              <LiveEmissionPlayer event={event} />
            </WarningLocalUrl>
          </PageSection>
        </RestrictedEventVisible>
      </QueryResponseHandler>
    </Dashboard>
  );
};

export default EventLiveEmissionPage;
